module.exports = __webpack_public_path__ + "static/RO_form_EN-221ce9a2d5075e9d5eebbd698c7aca0b.pdf";